import { render } from "./MarketingDate.vue?vue&type=template&id=5c957026&scoped=true"
import script from "./MarketingDate.vue?vue&type=script&lang=js"
export * from "./MarketingDate.vue?vue&type=script&lang=js"

import "./MarketingDate.vue?vue&type=style&index=0&id=5c957026&lang=scss&scoped=true"
import "./MarketingDate.vue?vue&type=style&index=1&id=5c957026&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c957026"]])

export default __exports__